import { workspaceRouter } from "@v2/trpc/routes/workspace";

/**
 * Owner or member of the workspace. Everything except the destructive
 * lifecycle actions (delete workspace, delete/move project) is open to both.
 */
export const useIsWorkspaceMember = (workspaceId?: string | null) => {
  const { data } = workspaceRouter.getUserWorkspacesList.useQuery();

  if (!workspaceId) {
    return false;
  }

  const userWorkspaceRole = data?.workspaces.find(
    (workspace) => workspace.id === workspaceId,
  )?.workspaceMemberships[0]?.role;

  return userWorkspaceRole === "owner" || userWorkspaceRole === "member";
};
